import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-white/80 backdrop-blur border-t border-gray-200">
      <div className="container mx-auto px-4 py-3 text-sm text-gray-700 flex flex-col sm:flex-row items-center sm:justify-between">
        <div className="mb-2 sm:mb-0 text-center sm:text-left">
          © {year} Nalozi. Sva prava zadržana.
        </div>
        <div className="text-center sm:text-right">
          Verzija 1.0.0
        </div>
      </div>
    </footer>
  );
};

export default Footer;
